import React, { useState } from 'react';
import '../css/animate.css';
import '../css/barvy.css';
import '../css/style.css';
import { useEffect } from 'react';
import { useRef } from 'react';
import { getLocalizedText } from '../utils/textLocalization';
import { getModelEntryData, useEditry } from '@lazylabs-dev/editry-react';
import { isEditryConfigured } from '../utils/editryConfig';
import { getCurrentLanguage } from '../utils/languageSwitcher';

const LOCALE_TO_CONTENT_LANGUAGE = {
  'cs-CZ': 'cs',
  'sk-SK': 'sk',
  'pl-PL': 'pl',
  'hu-HU': 'hu',
};

function App({ setModal, tableId }) {
  const { client } = useEditry();
  const editryReady = isEditryConfigured();
  const language = LOCALE_TO_CONTENT_LANGUAGE[getCurrentLanguage()] || 'cs';
  const modalRef = useRef(null);
  const [tabulka, setTabulka] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setModal({ show: false, id: null });
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setModal]);

  useEffect(() => {
    const fetchData = async () => {
      if (!tableId) {
        setTabulka({})
        return;
      }

      setLoading(true)
      setError(null)
      setTabulka({})

      try {
        if (!editryReady) {
          setError("Editry není nakonfigurováno.");
          return;
        }

        const modelsResponse = await client.getPublicModels();
        const tablesModel = modelsResponse?.data?.find((model) => model.slug === 'velikostni-tabulky');

        if (!tablesModel) {
          setError("Model velikostních tabulek nebyl nalezen.");
          return;
        }

        let itemsResponse = await client.getPublicModelItems(tablesModel.id, language);
        let items = itemsResponse?.data || [];

        if (!items.length) {
          itemsResponse = await client.getPublicModelItems(tablesModel.id);
          items = itemsResponse?.data || [];
        }

        const target = String(tableId);
        const foundItem = items.find((item) => {
          const data = getModelEntryData(item);
          const possibleIds = [
            String(item.id || ''),
            String(item.slug || ''),
            String(item.name || ''),
            String(data.id || ''),
            String(data.slug || ''),
            String(data.nazev || ''),
          ].filter(Boolean);

          return possibleIds.includes(target);
        });

        if (!foundItem) {
          setError("Tabulka s daným ID nebyla nalezena.");
          return;
        }

        setTabulka(getModelEntryData(foundItem));
      } catch (err) {
        console.error("Error fetching table:", err);
        setError("Chyba při načítání dat tabulky")
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [client, editryReady, language, tableId])

  const handleClose = () => {
    setModal({ show: false, id: null })
  }

  return (
    <>
        <div className="modal-box">
            <div ref={modalRef}>
                <button onClick={handleClose}><span>{getLocalizedText('table.close')}</span></button>
                {loading && <p>{getLocalizedText('table.loading')}</p>}
                {error && <p style={{ color: 'red' }}>{error}</p>}

                {!loading && !error && tabulka.nazev && (
                  <>
                <h2>{tabulka.nazev}</h2>
                <table className="modal-table">
                    <thead>
                        <tr>
                            <th>{getLocalizedText('table.size')}</th>
                            <th>{getLocalizedText('table.height')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tabulka.velikosti && Array.isArray(tabulka.velikosti) ? (
                            tabulka.velikosti.map((element, index) => (
                                <tr key={index}>
                                    <td>{element.nazev}</td>
                                    <td>{element.vyskaPostavy}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="2">{getLocalizedText('table.no_data')}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <h3>{getLocalizedText('table.disclaimer')}</h3>
                </>
                )}
            </div>
        </div>
    </>
  );
}

export default App;